import React, { useEffect, useState } from 'react';
import '@ant-design/v5-patch-for-react-19';
import { Amplify, Auth } from 'aws-amplify';

// import { Spin } from 'antd';

import SignIn from './auth/login';
import Home from './home';
import awsExports from "./aws-config";
import { getUserDetailsByEmail } from './api/userAPI';
import FullPageLoader from './Loading';
import { ResponsiveProvider } from './responsive/ResponsiveContext';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

Amplify.configure(awsExports);

export default function App() {
  const [userDetails, setUserDetails] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [userId, setUserId] = useState<number>();
  const [userName, setUserName] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');
  const [userRole, setUserRole] = useState<string>('');
  const [user, setUser] = useState<any>({});

  useEffect(() => {
    const fetchAuthenticatedUserDetails = async () => {
      try {
        const userData = await Auth.currentAuthenticatedUser();
        if (userData && userData.attributes && userData.attributes.email) {
          setUserDetails(userData.attributes.email);

          const { data: user, status: userStatus } = await getUserDetailsByEmail(userData.attributes.email);
          if (userStatus === "Success") {
            setUserId(user?.id);
            setUserEmail(user?.email);
            setUserName(user?.name);
            setUserRole(user?.role);
            setUser(user);
          }
        } else {
          console.error('No email found in user attributes');
          setUserDetails('');
        }
      } catch (error) {
        console.error('Error fetching user:', error);
        setUserDetails('');
      } finally {
        setLoading(false);
      }
    };

    fetchAuthenticatedUserDetails();
  }, []);

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setStyle({ style: Style.Light });
    }
  }, []);

  if (loading) {
    return <div><FullPageLoader /></div>;
  }

  return userDetails ?
    <ResponsiveProvider>
      <Home userId={userId} userEmail={userEmail} userName={userName} userRole={userRole} userStatus={user?.status} profilePath={user?.profileImagePath} />
    </ResponsiveProvider> :
    <SignIn />;
}